import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getLogoUrl, getSharedPortalName } from 'state/selectors/help-center';
import { Logo } from './logo';

const selector = createSelector(getLogoUrl, getSharedPortalName, (url, name) => ({ url, name }));

export default connect(selector)(Logo);
